import { ChevronDownOutline } from '@olist/design-system-icons';
import { margins, backgroundColor } from '@olist/styled-system';
import styled, { css } from 'styled-components';
import DropdownNamespace from '../Dropdown/Dropdown.js';
import Caption from '../Text/Caption/Caption.js';
import '../Text/DetailedSubheading/DetailedSubheading.js';
import '../Text/OverlineLg/OverlineLg.js';
import '../Text/OverlineMd/OverlineMd.js';
import '../Text/ParagraphLg/ParagraphLg.js';
import '../Text/ParagraphMd/ParagraphMd.js';
import '../Text/SectionHeading/SectionHeading.js';
import '../Text/SectionSubheading/SectionSubheading.js';
import '../Text/Title/Title.js';

const SelectWrapper = styled.div(({ feedback, theme: { olist: { components: { input }, }, }, }) => css `
    position: relative;
    width: 100%;
    margin-top: ${input.margin};

    svg {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }

    svg:nth-of-type(1) {
      right: 16px;
    }

    svg:nth-of-type(2) {
      right: 44px;
      ${feedback &&
    css `
        color: ${input.suprefix['feedback-icon'][feedback].color};
      `};
    }
  `);
const StyledSelect = styled.select(({ disabled, feedback, readOnly, theme: { olist: { components: { input }, }, }, }) => css `
    width: 100%;
    appearance: none;
    height: 48px;

    border-radius: ${input.radius};
    background-color: ${input['background-color']};
    outline: none;
    box-sizing: border-box;
    padding: 0;
    padding-left: ${input.padding};
    padding-right: ${parseInt(input.padding) * 3}px;
    font-family: ${input['font-family']};
    line-height: ${input['line-height']};

    font-size: ${input['font-size'].desktop};

    color: ${input.color};

    ${disabled
    ? css `
          border: 2px solid ${input.disabled['border-color']};
          background-color: ${input.disabled.background};
          cursor: not-allowed;
        `
    : feedback && feedback != 'valid' && !readOnly
        ? css `
          border: 2px solid ${input.feedback[feedback]['border-color']};
        `
        : css `
          border: 1px solid ${input['border-color']};
          ${readOnly
            ? css `
                background-color: ${input.readOnly.background};
              `
            : ''}
        `}

    &:focus {
      border: 2px solid ${input.focused['border-color']};
    }

    &::placeholder {
      color: ${input.placeholder.color};
      font-style: italic;
    }
  `);
const SelectMobileOptionalLabel = styled.span(({ theme: { olist: { components: { input }, }, }, }) => css `
    color: ${input.optionallabel.color};
    font-size: ${input.optionallabel['font-size']};
    font-family: ${input['font-family']};
    margin-left: ${input.optionallabel.margin};
    font-style: ${input.optionallabel['font-style']};
  `);
styled(ChevronDownOutline) `
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
`;
const Wrapper = styled.div `
  width: 100%;
  ${margins}
`;
const StyledDropdownItem = styled(DropdownNamespace.Item) `
  ${backgroundColor}
`;
const OptionText = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
const Mark = styled.mark(({ theme }) => css `
    background-color: unset;
    font-weight: ${theme.olist.fontWeight.bold};
  `);
const CategoryWrapper = styled.li `
  ul {
    list-style: none;
  }
`;
const ClearSearch = styled.button(({ theme }) => css `
    font-family: ${theme.olist.fontFamily.brand};
    font-size: ${theme.olist.fontSize['3xsmall']};
    font-weight: ${theme.olist.fontWeight.bold};
    color: ${theme.olist.color.primary.base};
    cursor: pointer;
    padding: 0;
    border: none;
    background-color: unset;
  `);
const EmptyStateMessage = styled.li `
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
const Category = styled(Caption).attrs({ bold: true })(({ theme: { olist: { color, spacing }, }, }) => css `
    display: block;
    margin-right: -${spacing.inline.small};
    margin-left: -${spacing.inline.small};
    margin-bottom: ${spacing.stack['1xsmall']};
    padding: ${spacing.stack['1xsmall']} ${spacing.inline.medium};
    border-bottom: 1px solid ${color.neutral.soft};
  `);
const StyledDropdown = styled(DropdownNamespace) ``;

export { Category, CategoryWrapper, ClearSearch, EmptyStateMessage, Mark, OptionText, SelectMobileOptionalLabel, SelectWrapper, StyledDropdown, StyledDropdownItem, StyledSelect, Wrapper };
